var DualRowPackageData = require('./dualRowPackageData.js');
var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var IpcDataModel = require("../index.js");

var DualRowPackageWithDifferentPadsData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    //pad height for odd pad which is different from others
    this.oddPadHeightMax = this.value("oddPadHeightMax", true);
    this.oddPadHeightMin = this.value("oddPadHeightMin", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadHeightMax);
    this.nonTransformedSegmentedGeometry.addTrigger(this.oddPadHeightMin);
 
};

lib_core.inherit(DualRowPackageWithDifferentPadsData, DualRowPackageData);
lib_core.JsonParser.registerClass(DualRowPackageWithDifferentPadsData, "DualRowPackageWithDifferentPadsData");

module.exports = DualRowPackageWithDifferentPadsData;

DualRowPackageWithDifferentPadsData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.minMaxPointerMap["oddPadHeight"] = [this.oddPadHeightMin, this.oddPadHeightMax];
    this.validationMap["oddPadHeightMax"] = [this.oddPadHeightMax];
};
/**
 * Calculate pads geometry
 * @param  {boolean} absolutePositions
 * @return {array} Array of pads.
 */
DualRowPackageWithDifferentPadsData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var hPitch = self.component.C,
        vPitch = self.verticalPinPitch(),
        motif = self.getMotif(),
        padWidth = motif.getTopCopper().width(),
        padHeight = motif.getTopCopper().height(),
        leftPadCount = self.component.padsPerSide[0],
        rowIdx,
        idx;

    //left pads
    for (idx = 0; idx < leftPadCount; idx++) {
        if(self.constructor === IpcDataModel.ToDpakData && self.hasTruncatedPin()) {
            if(idx === Math.floor(leftPadCount / 2)) { //middle I/O pins
                continue;
            }
        }
        
        rowIdx = idx % leftPadCount;

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord(-0.5 * hPitch, ((leftPadCount - 1) / 2 - rowIdx) * vPitch));
        pads.push(pad);
    }

    //update right pad
    //check on other max value is sufficient
    if (self.oddPadHeightMax()) {
        //right pad's either padHeightMin or padHeightMax is not same as that of left pad update pad size for right pad with new padHeightMin and padHeightMax
        if (self.oddPadHeightMax() !== self.padHeightMax() || self.oddPadHeightMin() !== self.padHeightMin()) {
            self.component.padHeightMax = self.oddPadHeightMax();
            self.component.padHeightMin = self.oddPadHeightMin();

            self.updateComponentCalculator(undefined, undefined, false);
            motif = self.getMotif();
        }
    }

    if (self.constructor === IpcDataModel.Dfn3Data || self.constructor === IpcDataModel.ToDpakData) {
        if (self.oddPadWidthMax()) {
            //right pad's either padWidthMin or padWidthMax is not same as that of left pad update pad size for right pad with new padWidthMin and padWidthMax
            if (self.oddPadWidthMax() !== self.padWidthMax() || self.oddPadWidthMin() !== self.padWidthMin()) {
                //update component with new padWidthMin and padWidthMax
                self.component.padWidthMax = self.oddPadWidthMax();
                self.component.padWidthMin = self.oddPadWidthMin();

                self.updateComponentCalculator(undefined, undefined, false);
                motif = self.getMotif();
            }
        }
    }

    //set corner radius to 0 for right pad
    motif.padstack().topCopper().rx(0);
    motif.padstack().topCopper().ry(0);

    //add right pad
    var pad = motif.clone();

    if (self.constructor === IpcDataModel.Sot223Data) {
        pad.move(new lib_geometry.Coord(0.5 * hPitch, 0));
    }
    //translate the odd pad towards the editor origin to correct odd pad end position
    else if (self.constructor === IpcDataModel.ToDpakData) {
        pad.move(new lib_geometry.Coord(hPitch / 2 - (pad.getTopCopper().width() / 2 - padWidth / 2), 0));
    } else if (self.constructor === IpcDataModel.Dfn3Data) {
        pad.move(new lib_geometry.Coord(self.horizontalLeadToLeadSpanMax() / 2 - pad.getTopCopper().width() / 2, 0));
    }

    pads.push(pad);

    self.updatePads(pads, absolutePositions);
    return pads;
};
